<template>
  <div>
    <!-- 首页地图图表组件，已废弃 -->
         <div class="leftcon">
             <v-chart :options="polar" :autoresize="true"/>
         </div>
  </div>
</template>
<script>
export default {
  data(){
    let data = []

    for (let i = 0; i <= 360; i++) {
        let t = i / 180 * Math.PI
        let r = Math.sin(2 * t) * Math.cos(2 * t)
        data.push([r, i])
    }
    return{
      polar:{
    title: {
        text: '周流量汇总',
        left: 'center',
        top: 10,
        textStyle: {
            color: '#ccc'
        }
    },
    tooltip : {
        trigger: 'axis',
                formatter:'{b}'+'</br>'+'{a0}:'+'{c0}'+'/MB'+'<br>'+'{a1}:'+'{c1}'+'/MB',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: 'rgb(8, 115, 255)'
            }
        }
    },
    grid: {
        left: '0.1%',
        right: '7%',
        bottom: '12%',
        containLabel: true
    },
    xAxis : [
        {   splitLine:{show: false},
            type : 'category',
            boundaryGap : false,
            data : ['周一','周二','周三','周四','周五','周六','周日']
        }
    ],
    yAxis : [
        {
            splitLine:{show: false},
            type : 'value'
        }
    ],
    series : [
        {
            name:'4G',
            type:'line',
            stack: '总量',
            areaStyle: {},
            data:[0, 132, 101, 134, 90, 230, 0]
        },
        {
            name:'有线',
            type:'line',
            stack: '总量',
            areaStyle: {},
            data:[0, 182, 191, 234, 290, 330, 0]
        }
    ]
}
    }
  },
  methods:{
    
  },
  mounted(){
    
  }
}
</script>
<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.leftcon{
    background-color: rgb(8, 115, 255);
    height: 25vh;
    border-radius:2%;
    width: 100%;
    margin: 0.2rem 0;
    overflow: hidden;
}
.leftcon .text{
  color: #ffffff;
  font-size:0.35rem;
  text-align: center;
  padding-top:0.1rem; 
}
.radius{
  margin-top:0.2rem;
  margin-left: 0.5rem; 
  display: inline-block;
  float: left;
}
.radiustext{
  color: #ffffff;
  text-indent: 0.2rem;
  font-size: 0.3rem;
  margin-top: 0.6rem;
}
.progress{
  display: inline-block;
  color: #ffffff;
}
.leftdiv{
  float: left;
}
</style>
